import { createContext } from 'react';
export function error(message) {
    return { type: 'error', content: message };
}
export function success(message) {
    return { type: 'success', content: message };
}
export function empty() {
    return {};
}
const MessageContext = createContext({
    setMessage: () => { },
});
export default MessageContext;
